import * as _ from "lodash";

import { Reducer } from "@ctra/utils";

import { cleanup } from "../../utils/reducer";
import types from "./types";
import { Favourites } from "./typings";
import { NormalizedFavouritesList } from "./schemas";

export const initialState: Favourites = {};

/**
 * Reducer of list of favourite charts
 * @param state
 * @param action
 * @category Reducer
 */
export const favouritesReducer: Reducer<Favourites> = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.FETCH_FAVOURITES.fulfilled: {
      const {
        entities: { charts },
        result
      } = payload as NormalizedFavouritesList;

      const mergedCharts = _.mapValues(result, (value: string) => _.pick(charts, value));

      return {
        ...state,
        ...mergedCharts
      } as Favourites;
    }
    case types.ADD_TO_FAVOURITES.fulfilled: {
      const { chart, farmID } = payload;

      return {
        ...state,
        [farmID]: {
          ...state[farmID],
          [chart.dataDescriptorID]: chart
        }
      };
    }
    case types.REMOVE_FROM_FAVOURITES.fulfilled: {
      const { chart, farmID } = payload;

      return {
        ...state,
        [farmID]: {
          ..._.omit(state[farmID], [chart.dataDescriptorID])
        }
      };
    }
  }

  return state;
};

export default cleanup<Favourites>(initialState)(favouritesReducer);
